import React from "react";
import './Package.css';

function Package () {

    return (
        <div className="poster">
            <h2>Start Working Now!</h2>
            <h3>Can list a number of jobs</h3>
            <p>Can also show locations available</p>
            <button className="btn" type="submit" >Show</button>
        </div>
    );
}

export default Package;